<template>
  <sidebar-menu :menu="userMenu" @toggle-collapse="onToggleCollapse" :collapsed= collapsed theme="white-theme" width ="224px" />
</template>
 
<script>
import axios from 'axios';
export default {
    data () {
    return {
  
    userMenu:[],

    // menu: [
    //           {
    //               header: true,
    //               title: 'Main Navigation',
    //               hiddenOnCollapse: true,
                  
    //           },
    //           {
    //               href: '/',
    //               title: 'Home',
    //               icon: 'fa fa-home',
    //               // hidden:true
    //           },
    //           {
    //               href: 'dashboard',
    //               title: 'Dashboard',
    //               icon: 'fa fa-user',
    //               // hidden: this.$auth.check(["Admin","Manager"]) ? false:true
    //           },
                  
    //       ]


    }
  },
methods:{
  onToggleCollapse(collapse)
  {
      this.$emit('sideBarToggled', collapse)
  }
},
  created(){
    
       let model = {
       "UserId":this.$auth.user().id
      }
       axios.post('/user/getMenus', model
      )
      .then(res=>{
        
            if(res.data.status == 1)
            {
                
                this.userMenu = res.data.data;
                // let routeRecord = {  
                //     title :"Database Backup",
                //     href:"/dbbackup",
                //     icon :"fas fa-life-ring"
                // }
                // this.userMenu.push(routeRecord);
                // let routeRecord = {  
                //     title :"Shipment Billing",
                //     icon :"fas fa-money-bill-alt",
                //     child: [
                //             {
                //                 href: '/unitrate',
                //                 title: 'Unit Rates',
                //             },
                //             {
                //                 href: '/shipmentbilling',
                //                 title: 'Generate Invoice'             
                //             },
                //         ]
                // }
                // let roleFlag = this.$auth.check(["Admin","Manager"]) ? false:true;
                // let routeRecord ={
                //   href: 'dashboard',
                //   title: 'Dashboard',
                //   icon: 'fa fa-tachometer-alt',
                //   hidden: roleFlag
                // }
                // this.userMenu.push(routeRecord);
                // console.log(res.data)
            }
            else
            {
              this.$bvModal.msgBoxOk('Error! '+res.data.msg, {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });      
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    
  },
  
    props: {
   
    // Sidebar Collapse state
    collapsed: {
      type: Boolean,
      default: false
    },
 
    // Sidebar width (expanded)
    width: {
      type: String,
      default: '350px'
    },
 
    // Sidebar width (collapsed)
    widthCollapsed: {
      type: String,
      default: '50px'
    },
 
    // Keep only one child opened at a time (first level only)
    showOneChild: {
      type: Boolean,
      default: false
    },
 
    // Keep all child open
    showChild: {
      type: Boolean,
      default: false
    },
 
    // Sidebar right to left
    rtl: {
      type: Boolean,
      default: false
    },
 
    // Make sidebar relative to the parent (by default the sidebar is relative to the viewport)
    relative: {
      type: Boolean,
      default: false
    },
 
    // Hide toggle collapse btn
    hideToggle: {
      type: Boolean,
      default: false
    },
 
    // Sidebar theme (available themes: 'white-theme')
    theme: {
      type: String,
      default: ''
    },
 
    // Disable hover on collapse mode
        disableHover: {
        type: Boolean,
        default: false
        }
    }
}

</script> 